module.exports = __webpack_public_path__ + "static/media/Property 1=Kim cương.db6d1dea.png";